/*
  assets/hrc-diagnostic-state.js
  Estado, navegacion y persistencia (Prompt Maestro seccion 5: flujo completo
  y reglas UX -- localStorage, restauracion, confirmacion antes de reiniciar).
*/
(function () {
  'use strict';

  var CFG = window.HRC_DIAGNOSTIC_CONFIG;

  var SCREENS = ['welcome', 'audience', 'context', 'instructions', 'questions', 'optional', 'teaser', 'lead', 'report'];

  // Auditoria (conexion V1 a la pagina real): la pagina de prueba y la
  // pagina real comparten origen, asi que localStorage se compartia entre
  // ambas bajo la misma clave -- el progreso de una se filtraba en la otra.
  // Clave estable para la pagina real (CFG.storageKey, sin cambios) y una
  // clave distinta SOLO para la ruta exacta conocida de la pagina de
  // prueba. Deliberadamente NO se deriva de pathname de forma generica
  // (eso rompería la persistencia de la pagina real si cambia su URL);
  // solo se compara contra esta unica ruta de prueba conocida.
  var TEST_PAGE_PATH = '/pages/test-diagnostico-hrc-v1';
  function effectiveStorageKey() {
    try {
      if (window.location.pathname === TEST_PAGE_PATH) return 'hrc_diagnostic_v1_test_state';
    } catch (e) {}
    return CFG.storageKey;
  }

  function emptyState() {
    return {
      screen: 'welcome',
      audience: null,
      context: {},
      questionIndex: 0,
      answers: {},
      perceivedLimitation: null,
      perceivedLimitationText: '',
      startedAt: null,
      questionsCompletedAt: null,
      lead: { name: '', email: '', consentRequired: false, consentMarketing: false },
      result: null
    };
  }

  function load() {
    try {
      var raw = window.localStorage.getItem(effectiveStorageKey());
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (e) { return null; }
  }

  function save(state) {
    try { window.localStorage.setItem(effectiveStorageKey(), JSON.stringify(state)); } catch (e) {}
  }

  function clear() {
    try { window.localStorage.removeItem(effectiveStorageKey()); } catch (e) {}
  }

  function createStore() {
    var state = load() || emptyState();
    var listeners = [];

    function notify() { listeners.forEach(function (fn) { fn(state); }); }

    return {
      getState: function () { return state; },
      hasSavedProgress: function () {
        var s = load();
        return !!(s && s.answers && Object.keys(s.answers).length > 0 && s.screen !== 'report');
      },
      subscribe: function (fn) { listeners.push(fn); },
      setScreen: function (screen) { state.screen = screen; save(state); notify(); },
      setAudience: function (audience) { state.audience = audience; save(state); notify(); },
      setContext: function (context) { state.context = context; save(state); notify(); },
      setAnswer: function (questionId, value) { state.answers[questionId] = value; save(state); notify(); },
      setQuestionIndex: function (i) { state.questionIndex = i; save(state); notify(); },
      setPerceivedLimitation: function (value, text) { state.perceivedLimitation = value; state.perceivedLimitationText = text || ''; save(state); notify(); },
      setLeadField: function (field, value) { state.lead[field] = value; save(state); notify(); },
      setResult: function (result) { state.result = result; save(state); notify(); },
      markStarted: function () { if (!state.startedAt) { state.startedAt = Date.now(); save(state); } },
      markQuestionsCompleted: function () { state.questionsCompletedAt = Date.now(); save(state); },
      elapsedSeconds: function () {
        if (!state.startedAt) return null;
        var end = state.questionsCompletedAt || Date.now();
        return Math.round((end - state.startedAt) / 1000);
      },
      reset: function () { state = emptyState(); clear(); notify(); },
      persist: function () { save(state); }
    };
  }

  window.HRC_DIAGNOSTIC_STATE = { SCREENS: SCREENS, createStore: createStore, emptyState: emptyState };
})();
